import React, {Component} from "react";
import Select from "../Select/Select";
import dimensions from "./dimensions";

class sizeCalculator extends Component {

  state = {
    system: "imperial",
    calculatedValue: null
  };

  onChange(evt) {

    let newState = {
      calculatedValue: null
    };

    newState[evt.target.name] = evt.target.value;

    this.setState(newState);
  }

  calculateValue() {
    let newState = {};
    if (this.state.width && this.state.height) {
      newState = {
        calculatedValue: dimensions[this.state.system + "Values"][parseInt(this.state.height, 10)][parseInt(this.state.width, 10)]
      };

      this.setState(newState);
    }
  }

  render() {
    let wOptions, hOptions;

    let uom = this.state.system === "imperial" ? " in" : " cm";

    wOptions = dimensions[this.state.system + "DimX"].map((v, i) => {
      return {
        name: v + uom,
        value: i
      };
    });

    hOptions = dimensions[this.state.system + "DimY"].map((v, i) => {
      return {
        name: v + uom,
        value: i
      }
    }).reverse();

    return (
      <div className="size-calculator__box-wrapper">
        <h5 className="mtn">Shipment dimensions</h5>
        <div className="size-calculator__fields-container">
          <div className="size-calculator__input-container">
            <Select
              name="height"
              title="Height"
              hasPleaseSelectOption={true}
              resetOnPropsUpdate={true}
              options={hOptions}
              onChange={(evt) => {
                this.onChange(evt)
              }}
              desktopWidth={'100%'}
              tabletWidth={'100%'}
              mobileWidth={'100%'}
            />
          </div>
          <div className="size-calculator__input-container">
            <Select
              name="width"
              title="Width"
              hasPleaseSelectOption={true}
              resetOnPropsUpdate={true}
              options={wOptions}
              onChange={(evt) => {
                this.onChange(evt)
              }}
              desktopWidth={'100%'}
              tabletWidth={'100%'}
              mobileWidth={'100%'}
            />
          </div>
          <div className="size-calculator__input-container">
            <Select
              name="system"
              title="In\Cm"
              options={[
                {
                  name: 'In',
                  value: 'imperial'
                },
                {
                  name: 'Cm',
                  value: 'metric'
                }
              ]}
              onChange={(evt) => {
                this.onChange(evt)
              }}
              desktopWidth={'100%'}
              tabletWidth={'100%'}
              mobileWidth={'100%'}
            />
          </div>
          <button
            onClick={() => {
              this.calculateValue()
            }}
            className="size-calculator__calculate-button cta-button">Calculate Length
          </button>
          <div className="size-calculator__result-container">
            <div className="input-label">Maximum length</div>
            <div className="size-calculator__result">{this.state.calculatedValue} {this.state.calculatedValue ? uom :
              <span>&nbsp;</span>}</div>
          </div>
        </div>
        <a className="size-calculator__link" href="./content/ship/assets/pdfs/Cargo_Bin_Limits_.pdf" target="_blank"
           rel="noreferrer noopener">View Chart</a>
      </div>
    )
  }
}

export default sizeCalculator;



// WEBPACK FOOTER //
// ./src/components/SizeCalculator/SizeCalculator.js